import Vue from 'vue';
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import log from '@/commons/systemCommon/log.js';
import '../../assets/css/common.css';
import util from '@/commons/util.js';
import api from '@/commons/api.js';
import store from '@/commons/store';
import regex from '@/commons/regex.js';
import common from '@/commons/common.js';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';
import permission from './permission.js';
/*import aopUtil from './aopUtil.js';*/
import '../../components/baseComponents/directives.js';
import dataBusUtil from '@/commons/webSocketCommon/dataBusUtils/dataBusUtils.js';
import apiAxios from './apiAxios';
import VueClipboard from 'vue-clipboard2';
import { banBackSpace } from '@/commons/preventBackspace.js';
import cookies from 'js-cookie';
import socketApi from '@/commons/webSocketCommon/socketUtil/socketUtil.js';
import watermark from '@/commons/watermark.js';
import QRCode from 'qrcodejs2';
import systemUtil from '@/commons/systemUtil.js';
import moment from 'moment';
import onlineUsers from '@/commons/onlineUsers.js';
/* 登录验证方法 */
window.validateLogon = {
    loginMethod: new Map(),
    /*登录程序 */
    loginPorcess: []
};
/* 密码登录 */
import userPwdLoginCheck from '@/commons/userPwdLoginCheck.js';
window.validateLogon.loginMethod.set('Password', userPwdLoginCheck);
Vue.use(VueClipboard);
Vue.use(permission);
Vue.use(Element);
Vue.config.productionTip = false;
/* eslint-disable no-new */
Vue.prototype.$util = util;
Vue.prototype.userPwdLoginCheck = userPwdLoginCheck;
Vue.prototype.$log = log;
Vue.prototype.$store = store;
Vue.prototype.$regex = regex;
Vue.prototype.$common = common;
/*Vue.prototype.$aopUtil = aopUtil;*/
Vue.prototype.$echarts = window.echarts;
Vue.prototype.$dataBusUtil = dataBusUtil;
Vue.prototype.$apiAxios = apiAxios;
Vue.prototype.$upperFirst = upperFirst;
Vue.prototype.$camelCase = camelCase;
Vue.prototype.$api = api;
Vue.prototype.$cookies = cookies;
Vue.prototype.$socketApi = socketApi;
Vue.prototype.$watermark = watermark;
Vue.prototype.$QRCode = QRCode;
Vue.prototype.$systemUtil = systemUtil;
Vue.prototype.$EventBus = new Vue();
Vue.prototype.$moment = moment;
Vue.prototype.$onlineUsers = onlineUsers;
// 全局导入组件
const requireComponent = require.context(
    // 其组件目录的相对路径
    '../../components/baseComponents/',
    // 是否查询其子目录
    false,
    // 匹配基础组件文件名的正则表达式, 这里可以匹配的文件名为TdXxxx.vue格式
    /Td[A-Z]\w+\.(vue|js)$/
);
requireComponent.keys().forEach(fileName => {
    // 获取组件配置
    const componentConfig = requireComponent(fileName);

    // 获取组件的 PascalCase 命名
    const componentName = upperFirst(
        camelCase(
            // 剥去文件名开头的 `'./` 和结尾的扩展名
            fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
        )
    );
    // 全局注册组件
    Vue.component(
        componentName,
        // 如果这个组件选项是通过 `export default` 导出的，
        // 那么就会优先使用 `.default`，否则回退到使用模块的根。
        componentConfig.default || componentConfig
    );
});
document.onkeypress = banBackSpace;
document.onkeydown = banBackSpace;
//引入vue-grid-layout
import VueGridLayout from 'vue-grid-layout';
var GridLayout = VueGridLayout.GridLayout;
var GridItem = VueGridLayout.GridItem;
Vue.component(GridLayout);
Vue.component(GridItem);
Vue.prototype.$EventBus.$on('eventMouduleAbout', menu => {
    let about = require('./eventAbout');
    debugger;
    about.default.install(window.vue.$t('navbar.ABOUT'));
});
